const dev = {
  BASE_URL: process.env.REACT_APP_STAGING_API_URL,
};

const prod = {
  BASE_URL: process.env.REACT_APP_PRODUCTION_API_URL,
};

export const config = process.env.REACT_APP_BUILD_ENV === 'production' ? prod : dev;
